import { makeStyles } from "@fluentui/react-components";

export const useSelectedTagsListStyles = makeStyles({
  tagsGroup: {
    flexWrap: "wrap",
    gap: "5px",
    padding: "5px 5px 0",
  },
  selectedTagsList: {
    maxHeight: "45vh",
    overflowX: "hidden",
    overflowY: "auto",
  },
  tagText: {
    textOverflow: "ellipsis",
  },
});
